'use client'

import { onlineManager } from '@tanstack/react-query'
import { WifiOff } from 'lucide-react'
import { useSyncExternalStore } from 'react'

/**
 * TanStack Query's `onlineManager` already pauses/resumes query activity on its own — this
 * component only adds the visible banner on top of that existing detection, per
 * `frontend-code-standards.md` §15. Mounted once near the app shell (`src/providers/index.tsx`),
 * not per-page.
 */
function useIsOnline() {
  return useSyncExternalStore(
    (callback) => onlineManager.subscribe(callback),
    () => onlineManager.isOnline(),
    () => true,
  )
}

export function OfflineBanner() {
  const isOnline = useIsOnline()
  if (isOnline) return null

  return (
    <div
      role="status"
      className="bg-destructive/10 text-destructive flex items-center justify-center gap-2 px-4 py-2 text-sm"
    >
      <WifiOff className="size-4" aria-hidden />
      You&apos;re offline — changes will resume once you&apos;re back online.
    </div>
  )
}
